// DrStack brand mark — gradient hexagon + navy ECG line, rendered inline exactly as on the
// original site (see src/assets/logo.svg / logo-lockup.svg for the standalone files). The gradient
// id must be unique per instance because the mark renders twice on the page (nav + footer).
export function LogoMark({ size, gradientId }: { size: number; gradientId: string }) {
  return (
    <svg width={size} height={size} viewBox="-6 -6 132 132" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#2563EB" />
          <stop offset=".5" stopColor="#0EA5E9" />
          <stop offset="1" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
      <path
        d="M60 0 L112 30 L112 90 L60 120 L8 90 L8 30 Z"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="9"
        strokeLinejoin="round"
      />
      <path
        d="M22 60 L44 60 L54 38 L66 82 L76 60 L98 60"
        fill="none"
        stroke="#0F2A43"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Two-tone "DrStack" wordmark ("Dr" navy, "Stack" teal via .logo-word span). */
export function LogoWord() {
  return (
    <span className="logo-word">
      Dr<span>Stack</span>
    </span>
  );
}
